import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject, Observable, takeUntil } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class LoadingService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    private activeRequests = 0;

    loading$: Observable<boolean> = this.loadingSubject.asObservable();

    constructor(private zone: NgZone) {}

    show() {
        this.activeRequests++;
        if (this.activeRequests === 1) {
            this.updateLoadingState(true);
        }
    }

    hide() {
        if (this.activeRequests > 0) {
            this.activeRequests--;
        }
        if (this.activeRequests === 0) {
            this.updateLoadingState(false);
        }
    }

    /**
     * Suppresses the global loading spinner
     *
     * @param destroy$ Observable that emits when the component is destroyed (used to unsubscribe)
     */
    suppressGlobalSpinner(destroy$: Observable<void>): void {
        this.loading$.pipe(takeUntil(destroy$)).subscribe((isLoading) => {
            if (isLoading) {
                this.hide();
            }
        });
    }

    /**
     * This ensures that Angular's change detection is triggered whenever the loading state changes. Without this,
     * Angular's change detection may improperly detect loading state changes (ex: false -> true) that happen swiftly.
     * For more info on the error this solves: https://stackoverflow.com/questions/43375532/expressionchangedafterithasbeencheckederror-explained.
     */
    private updateLoadingState(isLoading: boolean) {
        this.zone.run(() => {
            // setTimeout ensures that the current change detection cycle is over before running this manual change detection.
            setTimeout(() => {
                this.loadingSubject.next(isLoading);
            }, 0);
        });
    }
}
